import { getFoods, setFoods  } from '../state-manager.js';
// import { fetchFoods } from '../requests/profiles.js';
import { FoodInteractionController } from './food-controller.js';
import { loadClientFoods } from '../requests/foods.js';

let foodController;

export async function hydrateFoods(profileId = null) {
  const panel = document.getElementById('app-foods-panel');
  const container = panel?.querySelector('.table-rows');
  if (!panel || !container) return;
  console.log('[UI-Foods] Hydrating foods for profile:', profileId);
  panel?.classList.remove('hidden');

  const clientFoods = getFoods();

  container.innerHTML = '';

  if (!clientFoods || clientFoods.length === 0) {
    console.log('[UI-Foods] No foods found in the state.');
    return;
  }

  function filterByProfileId(dataArray, profileId) {
    return dataArray.filter(item => item.profile_ids.includes(profileId));
  }

  const foods = profileId ? filterByProfileId(clientFoods, profileId) : clientFoods;
  if (!foods || foods.length === 0) {
    console.log('[UI-Foods] No foods found for the given profile or client.');
    return;
  }
  console.log('[UI-Foods] Foods fetched:', foods.length, 'items');
  foods.forEach(food => {
    if (food.active === 0) return; // Skip inactive foods

    const row = document.createElement('tr');
    row.className = 'food-row';
    row.dataset.foodId = food.id;

    const nameCell = document.createElement('td');
    nameCell.textContent = food.name;

    const weightCell = document.createElement('td');
    weightCell.textContent = parseInt(food.weight, 10);

    row.appendChild(nameCell);
    row.appendChild(weightCell);
    container.appendChild(row);
  });

  // console.log('[hydrateFoods] Rendered HTML:', container.innerHTML);
  // console.log('[hydrateFoods] Child count:', container.children.length);
  // Initialize controller once after rendering
  await Promise.resolve(); // yield to event loop
  foodController = new FoodInteractionController('tbody#food-tags');
  foodController.bind(); 
}

// Expose activation method to slider
export function activateFoodsForPortion(portion) {
  console.log('[UI-Foods] Activating foods for portion:', portion);
  if (foodController) foodController.activate(portion);
}

export function deactivateFoods() {
  console.log('[UI-Foods] Deactivating foods');
  foodController?.deactivate();
}

export async function getClientFoods() {
  // Fetch foods for the client
  const clientFoods = await loadClientFoods();
  if (!clientFoods || clientFoods.length === 0) {
    console.log('[UI-Foods - getClientFoods] No foods loaded for the client.');
    return;
  }
  setFoods(clientFoods);
  console.log('[UI-Foods - getClientFoods] Foods loaded:', clientFoods.length, 'items');
}
